import styled, {css} from 'styled-components';

const reset = css`
	width: 100%;
	padding: 0;
`;

export default styled.div`
	max-width: var(--px-200);
	.DocumentNameWrapper {
		padding-right: 0;
		padding-left: var(--px-20);
	}
	.DocumentNameContainer {
		width: 100%;
		.DocumentSVG,
		.DocumentNameDetails .documentName-icons {
			display: none;
		}
		.DocumentNameDetails {
			${reset}
			.DocumentName {
				${reset}
				.DocumentNameText {
					${reset}
				}
			}
		}
	}
`;
